module.exports = __webpack_public_path__ + "static/media/General_Template_For_Comments_Importation.dea777fd.xlsx";